export default function Marquee() {
  const items = [
    "Confidence starts here",
    "Curated with love",
    "For girls 4 – 15",
    "Seasonal keepsakes",
    "Made in small batches",
    "Big love, tiny boxes",
  ];
  const repeated = [...items, ...items, ...items];
  return (
    <div
      className="border-y border-[#E8D7D0] bg-[#F9F6F0] overflow-hidden no-scrollbar"
      data-testid="value-marquee"
    >
      <div className="py-5 overflow-hidden">
        <div className="me-marquee-track">
          {repeated.map((text, i) => (
            <span
              key={i}
              className="flex items-center gap-8 text-[11px] tracking-[0.35em] uppercase text-[#7D6B6D]"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-[#C48B9F]" />
              {text}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
